import React, { useState } from "react";
import { IconButton, InputAdornment, MenuItem, TextField } from "@material-ui/core";
import ChevronDown from "../../resources/wrappers/ChevronDownIcon";
import './Select.scss';

const Select = (props: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [rotateAnimation, setRotateAnimation] = useState(false);
  const [value, setValue] = useState('');

  const handleIconClick = () => {
    setOpenModal(prevState => !prevState)
    setRotateAnimation(prevState => !prevState)
  };

  return (
    <div className="custom-select">
      <TextField
        className={props.volumeIsValid ? 'box-error-select' : ''}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end" onClick={handleIconClick}>
                <div className={`custom-icon-wrapper ${rotateAnimation ? "rotate" : ""}`}>
                  <ChevronDown width={16} height={16} fill="#2D32AA" />
                </div>
              </IconButton>
            </InputAdornment>
          ),
          onClick: () => {
            if (!openModal) {
              handleIconClick();
            }
          },
        }}
        id="select"
        select
        label={props.label}
        value={props.value}
        onChange={(event) => {
          setOpenModal(false);
          setRotateAnimation(false);
          props.setNewValue(event.target.value as string)
          setValue(event.target.value)
        }}
        onBlur={() => openModal}
        SelectProps={{
          open: openModal,
          onClose: handleIconClick,
          onOpen: () => {
            if (value === props.volumeList[1]) {
              setTimeout(() => {
                const el = document.querySelector<HTMLElement>('.MuiPopover-root');
                // @ts-ignore
                if (el) el.style.inset = '40px 0 0'
              }, 50);
            }
            else if (value === props.volumeList[2]) {
              setTimeout(() => {
                const el = document.querySelector<HTMLElement>('.MuiPopover-root');
                // @ts-ignore
                if (el) el.style.inset = '80px 0 0'
              }, 50);
            }
            else if (value === props.volumeList[3]) {
              setTimeout(() => {
                const el = document.querySelector<HTMLElement>('.MuiPopover-root');
                // @ts-ignore
                if (el) el.style.inset = '120px 0 0'
              }, 50);
            }
            handleIconClick()
          },
        }}
      >
        {props.volumeList && props.volumeList.length > 0 && props.volumeList.map((v: string) => (
          <MenuItem
            key={v}
            value={v}
            disableRipple
          >
            {v}
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}

export default Select;
